import { EntityType } from '../Entities';
import { committeeEntityConfig } from './committee-entity';
import { consultantEntityConfig } from './consultant-entity';
import { dpohEntityConfig } from './dpoh-entity';
import { firmEntityConfig } from './firm-entity';
import { inactiveOrgEntityConfig } from './inactive-organization-entity';
import { institutionEntityConfig } from './institution-entity';
import { issueEntityConfig } from './issue-entity';
import { mpEntityConfig } from './mp-entity';
import { organizationEntityConfig } from './organization-entity';
import { sectorEntityConfig } from './sector-entity';
import { senateCommitteeEntityConfig } from './senate-committee-entity';
import { senatorEntityConfig } from './senator-entity';
import { subjectEntityConfig } from './subject-entity';

export class ConfigDescriptor {
    static getEntityConfig(entityType: EntityType): any {
        let entityConfig: any;

        switch (entityType) {
            case EntityType.Issues:
                entityConfig = issueEntityConfig;
                break;
            case EntityType.Institution:
                entityConfig = institutionEntityConfig;
                break;
            case EntityType.MP:
                entityConfig = mpEntityConfig;
                break;
            case EntityType.DPOH:
                entityConfig = dpohEntityConfig;
                break;
            case EntityType.SenateCommittee:
                entityConfig = senateCommitteeEntityConfig;
                break;
            case EntityType.SenateMember:
                entityConfig = senatorEntityConfig;
                break;
            case EntityType.Sector:
                entityConfig = sectorEntityConfig;
                break;
            case EntityType.Organization:
                entityConfig = organizationEntityConfig;
                break;
            case EntityType.InactiveOrganization:
                entityConfig = inactiveOrgEntityConfig;
                break;
            case EntityType.Subject:
                entityConfig = subjectEntityConfig;
                break;
            case EntityType.Firm:
                entityConfig = firmEntityConfig;
                break;
            case EntityType.Consultant:
                entityConfig = consultantEntityConfig;
                break;
            case EntityType.Committee:
                entityConfig = committeeEntityConfig;
                break;
        }

        return entityConfig;
    }
}
